import Delimiter from "../../util/delimiter";
import "./main_nav_bar.css";
import { Link } from "react-router-dom";

function MainNavBar() {
  return (
    <ul className="main_nav_bar">
      <li className="intro">
        <Link to="/intro/greeting">센터 소개</Link>
        <ul className="items" id="intro">
          <li>
            <Link to="/intro/greeting">인사말</Link>
          </li>
          <li>
            <Link to="/intro/facility">시설 소개</Link>
          </li>
          <li>
            <Link to="/intro/roadmap">오시는 길</Link>
          </li>
        </ul>
      </li>
      <Delimiter />
      <li className="procedure">
        <Link to="/procedure">이용절차</Link>
      </li>
      <Delimiter />
      <li className="charge">
        <Link to="/charge/table">이용요금</Link>
      </li>
      <Delimiter />
      <li className="service">
        <Link to="/service/define">
          방문요양<div className="line_break" id="nav_bar" hidden></div>서비스
        </Link>
        <ul className="items" id="service">
          <li>
            <Link to="/service/define">방문요양이란</Link>
          </li>
          <li>
            <Link to="/service/detail">서비스 내용</Link>
          </li>
          <li>
            <Link to="/service/matching">요양사 매칭</Link>
          </li>
        </ul>
      </li>
      <Delimiter />
      <li className="community">
        <Link to="/community/notice">커뮤니티</Link>
        <ul className="items" id="community">
          <li>
            <Link to="/community/notice">공지사항</Link>
          </li>
          <li>
            <Link to="/community/info">정보마당</Link>
          </li>
          <li>
            <Link to="/community/qna">자주 묻는 질문</Link>
          </li>
        </ul>
      </li>
    </ul>
  );
}

export default MainNavBar;
